﻿import ExpandableTable from "@/components/desktop/list/table/ExpandableTable";
import CustomBadge from "@/components/desktop/badge/CustomBadge";
import CustomButton from "@/components/desktop/button/CustomButton";
import { useNavigate } from "react-router-dom";
import { Eye, Pencil } from "lucide-react";
import { getApplicationOrderStateVariant } from "@/constants/applicationOrderStates";

const PhytosanitaryProgramOAs = ({ OAs }) => {
	const navigate = useNavigate();

	const handleView = (id) => {
		navigate(`/orden_aplicacion/ver/${id}`);
	};

	const handleEdit = (id) => {
		navigate(`/orden_aplicacion/editar/${id}`);
	};

	const columns = [
		{
			key: "code",
			label: "N° OA",
			render: (value) => (
				<CustomBadge variant="dark" size="lg" pill={false}>
					{value || "-"}
				</CustomBadge>
			),
		},
		{
			key: "application_order_date",
			label: "Fecha Aplicación",
			render: (value) => {
				if (!value) return "-";
				const date = new Date(value);
				return date.toLocaleDateString("es-CL");
			},
		},
		{
			key: "business_centers",
			label: "Sectores",
			render: (businessCenters) => {
				if (!businessCenters || businessCenters.length === 0) return <span>-</span>;
				return (
					<div style={{ display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center" }}>
						{businessCenters.map((bc, index) => (
							<CustomBadge key={index} variant="outline" size="sm">
								{bc.business_center_name} ({bc.area_ha} ha)
							</CustomBadge>
						))}
					</div>
				);
			},
		},
		{
			key: "responsible_user_name",
			label: "Responsable",
			render: (value) => value || "-",
		},
		{
			key: "state_id",
			label: "Estado",
			render: (value, row) => {
				return (
					<CustomBadge variant={getApplicationOrderStateVariant(Number(value))} size="md">
						{row.state_text || "-"}
					</CustomBadge>
				);
			},
		},
		{
			key: "actions",
			label: "Acciones",
			render: (value, row) => {
				return (
					<div style={{ display: "flex", gap: "0.5rem", justifyContent: "center" }}>
						<CustomButton variant="ghost" size="sm" startIcon={<Eye size={16} />} onClick={() => handleView(row.id)} title="Ver"></CustomButton>
						<CustomButton
							variant="ghost"
							size="sm"
							startIcon={<Pencil size={16} />}
							onClick={() => handleEdit(row.id)}
							title="Editar"
						></CustomButton>
					</div>
				);
			},
		},
	];

	return <ExpandableTable title={`Órdenes de Aplicación`} subtitle={`Total de órdenes: ${OAs.length}`} columns={columns} data={OAs} rowKey="id" />;
};

export default PhytosanitaryProgramOAs;
